import React, { useState, useEffect, createContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './pages/login.js';
import StartWorkflow from './pages/newWorkflow.js';
import Users from './pages/users.js';
import TasksTablePage from './pages/tasks.js';
import Workflows from './pages/workflows.js';
import Roles from './pages/roles.js';
import GruppenBuilder from './pages/groups.js';
import Automations from './pages/automations.js';

export const AuthContext = createContext();

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAuth = !!user;

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <Router>
        <div className="app-container">
          {isAuth && <Sidebar onLogout={handleLogout} />}
          <main className="app-content">
            <Routes>
              <Route path="/login" element={isAuth ? <Navigate to="/new_workflow" /> : <Login />} />
              <Route path="/new_workflow" element={isAuth ? <StartWorkflow /> : <Navigate to="/login" />} />
              <Route path="/users" element={isAuth ? <Users /> : <Navigate to="/login" />} />
              <Route path="/tasks" element={isAuth ? <TasksTablePage /> : <Navigate to="/login" />} />
              <Route path="/gruppen" element={isAuth ? <GruppenBuilder /> : <Navigate to="/login" />} />
              <Route path="/workflows" element={isAuth ? <Workflows /> : <Navigate to="/login" />} />
              <Route path="/roles" element={isAuth ? <Roles /> : <Navigate to="/login" />} />
              <Route path="/automations" element={isAuth ? <Automations /> : <Navigate to="/login" />} />
              <Route path="/" element={<Navigate to={isAuth ? "/new_workflow" : "/login"} />} />
              <Route path="*" element={<Navigate to={isAuth ? "/new_workflow" : "/login"} />} />
            </Routes>
          </main>
        </div>
      </Router>
    </AuthContext.Provider>
  );
};

const Sidebar = ({ onLogout }) => {
  const userData = JSON.parse(localStorage.getItem('user'))
  console.log("userData: ",userData)

  const navigate = useNavigate();
  return (
    <aside className="sidebar">
      <div className="logo">
        <h1>Flowliner</h1>
      </div>
      <nav className="menu">
        <ul>
          <li onClick={() => navigate('/new_workflow')}>New Workflow</li>
          <hr className="menu-divider" />
          <li onClick={() => navigate('/workflows')}>Workflows</li>
          <li onClick={() => navigate('/gruppen')}>Gruppen</li>
          <li onClick={() => navigate('/tasks')}>Tasks</li>
          <li onClick={() => navigate('/roles')}>Roles</li>
          <li onClick={() => navigate('/automations')}>Automatisierungen</li>
          <hr className="menu-divider" />
          <li onClick={() => navigate('/users')}>Users</li>
          <hr className="menu-divider" />
          <li>
            <a
              href="https://fliessbandbetrieb.gitbook.io/flowliner"
              target="_blank"
              rel="noopener noreferrer"
            >
              KURS
            </a>
          </li>
        </ul>
      </nav>
      <div className="user-section">
        <h2 className="username">{userData.username}</h2>
        <p className="workspace-name">{userData.workspace_name[0]}</p>
        <button className="logout-button" onClick={onLogout}>Logout</button>
      </div>
    </aside>
  );
};

export default App;